import { Output, EventEmitter, Input, OnInit, Component } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { OrientationService } from "../../../../../phf.service";

@Component({
    selector: 'orientation-carrier-window',
    templateUrl: './orientation-carrier.component.html',
    styleUrls: ['../../part-detail.component.scss']
})

export class OrientationCarrierDialog implements OnInit {
    orientationCarrierEditForm: FormGroup;
    part: any;
    public opened: boolean

    @Input()
    set data(editForm: FormGroup) {
        if (editForm) {
            this.part = editForm.value;
        }
    }

    @Output()
    save: EventEmitter<any> = new EventEmitter();
    @Output()
    close: EventEmitter<any> = new EventEmitter();

    constructor
        (
        private readonly formBuilder: FormBuilder,
        public readonly orientationService: OrientationService
        ) {
        this.orientationService.read();
    }

    ngOnInit() {
        this.orientationCarrierEditForm = this.formBuilder.group(OrientationCarrierForm);
        this.orientationCarrierEditForm.reset(this.part);
    }

    closeWindow() {
        this.close.emit();
        this.opened = false;
    }

    // Builds and passes OrientationNote value to the FirstOrientation editForm in PartLoading tab
    onSave() {
        this.save.emit(this.orientationCarrierEditForm.get('FirstOrientation').value);
    }

    onClicked = (dataItem, orientation) => {
        const orientationDescription = this.orientationService.value.find(x => x.Id === dataItem);
        if (this.orientationCarrierEditForm.get("FirstOrientation").value) {
            const description = (orientationDescription ? ` ${orientationDescription.Description}` : '') + ` ${orientation},`;
            const orientationNote = this.orientationCarrierEditForm.get("FirstOrientation").value.concat(description);
            this.orientationCarrierEditForm.get("FirstOrientation").setValue(orientationNote);
        } else {
            this.orientationCarrierEditForm.get("FirstOrientation").setValue((orientationDescription ? orientationDescription.Description : '') + ` ${orientation},`);
        }
    }
}

const OrientationCarrierForm = {
    FirstOrientation: [],
}


